import React, { useState } from 'react'
import './ContactForm.css'


const Form = () => {
  const [fname, setfname] = useState('')
  const [lname, setlname] = useState('')
  const [email, setemail] = useState('')
  const [query, setquery] = useState('GeneralEnquiry')
  const [msg, setmsg] = useState('')
  const [isconsent,setisconsent] = useState(false)
  
  const handleSubmit =(e)=>{
    e.preventDefault();

  }

  return (
    <div className='container'>
      
        
      <h3>Contact Us</h3>
      <form onSubmit={handleSubmit} className='contact'>
      
     
        <div> 
          <label htmlFor="fname">First Name</label>
          <input type='text' id='fname' value={fname} onChange={(e)=>{setfname(e.target.value)}} required/>
        </div>
        <div>
          <label htmlFor="lname">Last Name</label>
          <input type='text' id='lname' value={lname} onChange={(e)=>{setlname(e.target.value)}} required/>
        </div>
        
          
        
        <div className='full'> 
          
          <label htmlFor="email">Email</label>
        </div>
        <div className='full'> 
          <input type='text' id='email' style={{width:'90%'}} value={email} onChange={(e)=>{setemail(e.target.value)}} required/>
        </div>
        <div className='full'>
          <label>Query Type</label>
        </div>
        
          <div className='radio-group'>
            <label htmlFor="">
            <input type='radio' name='queryType' value={query} checked = {query==='GeneralEnquiry'} 
              onChange={(e)=>{setquery(e.target.value)}} />
              General Enquiry
            </label>
          </div>
          <div className='radio-group'>
            <label htmlFor="">
            <input type='radio' name='queryType' value='Supportrequest' checked = {query==='Supportrequest'} 
              onChange={(e)=>{setquery(e.target.value)}} />
              Support request
            </label>
          
        </div>
        <div className='full '> 
          <label htmlFor="msg">Message</label>
          <textarea  id='msg' value={msg} onChange={(e)=>{setmsg(e.target.value)}}/>
        </div>
        <div className='full'>
          <div>
          <input 
            type="checkbox"
            id="isConsented"
            name="isConsented"
            checked={isconsent}
            onChange={(e)=>setisconsent(e.target.value)}
            required
          />
        </div>
        <label htmlFor="isConsented" >I consent to being contacted by the team</label>
      </div>
      <div className='full'>
        <button type="submit" disabled={!isconsent}>
          Submit
        </button>
      </div>
      </form>
    
    </div>
  )
}

export default Form